<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div style="overflow-x: auto">
      <table aria-label="Tableau affichant les animaux"
             class="table table-bordered table-striped table-border-purple table-head-purple">
        <thead class="thead-default">
        <tr>
          <th class="text-center" i18n="@@animalSpecies" scope="col">Species</th>
          <th class="text-center" i18n="@@animalCategory" scope="col">Category</th>
          <th class="text-center" i18n="@@quantity" scope="col">Quantity</th>
          <th class="text-center" i18n="@@weight" scope="col">Weight</th>
          <th *ngIf="autopsyColDisplay" class="text-center" i18n="@@autopsy" scope="col">Autopsy</th>
          <th class="text-center" i18n="@@amount" scope="col">Amount</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let d of data">
          <td class="text-center">{{ d?._embedded?.animalSpecies?.tag }}</td>
          <td class="text-center">{{ d?._embedded?.animalCategory?.tag }}</td>
          <td class="text-center">{{ d?.quantity }}</td>
          <td class="text-center">{{ d?.weightE }} kg</td>
          <th class="text-center" *ngIf="autopsyColDisplay">{{d?._embedded?.autopsy?.tag}}</th>
          <td class="text-center">{{ d?.amount }} &euro;</td>
        </tr>
        <tr>
          <td [attr.colspan]="autopsyColDisplay ? 5 :4" class="text-right font-bold" i18n="@@totalAmount">
            Total amount:
          </td>
          <td class="text-center font-bold">{{ totalAmount }} &euro;</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
